import React, { useState } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import { getLang } from '~/commons/helpers';
import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';
import BtnDayRangeWithTimePicker from '../btns/BtnDayRangeWithTimePicker.jsx';
import { env } from '../../config';

const api = '/api/core/users/students/stats';

const ListScores = () => {
  const [filter, setFilter] = useState({});
  const isAdmin = env.user.roles.includes('admin');
  const stage = env?.school?.stage;
  const { t, i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  // Debug logging
  console.log('🔍 ListScores - Current filter:', filter);
  console.log('🔍 ListScores - API endpoint:', api);

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'name', label: 'Name' },
          ...(env.user.schoolClass ? [] : [
            { value: 'schoolClass.title', label: 'Class' },
            {
              value: 'schoolClass.grade',
              label: 'Grade',
              options: Object.keys(env.grades)
                .filter((g) => {
                  if (stage === 'p') return g <= 6;
                  if (stage === 's') return g >= 7;

                  return true;
                })
                .map((g) => ({
                  value: g,
                  label: env.grades[g][lang],
                })),
            },
          ]),
          { value: 'studentId', label: 'Class No.' },
          ...isAdmin ? [{
            value: 'school.title', label: 'School',
          }] : [],
          {
            value: 'assignment',
            label: '階段',
            options: [
              { value: '1', label: '1' },
              { value: '2', label: '2' },
              { value: '3', label: '3' },
            ],
          },
        ],
        filter,
        api,
        sort: { 'name.full.en': 1 },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: true,
        },
        cols: [
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => getLang(get(r, 'name.full'), lang),
          },
          {
            key: 'lv',
            children: 'Group',
            sortable: true,
            getter: (v) => env.lvs[v][lang],
          },
          ...(isAdmin ? [
            {
              key: 'school.title.en',
              children: 'School',
              getter: (v, r) => getLang(get(r, 'school.title'), lang),
            },
          ] : []),
          // {
          //   key: 'schoolClass.acadYear',
          //   children: 'Year',
          //   getter: (v) => (`${v}/${v + 1}`),
          // },
          {
            key: 'schoolClass.grade',
            children: 'Grade',
            sortable: true,
            getter: (v) => env.grades[v][lang],
          },
          {
            key: 'schoolClass.title',
            children: 'Class',
            sortable: true,
          },
          {
            key: 'studentNo',
            children: 'Class No.',
            sortable: true,
            getter: (v, r) => r.studentId,
          },
          {
            key: 'articleScore',
            children: 'Article Total Score',
            sortable: true,
            getter: (v, r) => (v || 0),
          },
          {
            key: 'score',
            children: 'Academic Year Score',
            sortable: true,
            getter: (v, r) => (v || 0),
          },
          // {
          //   key: '"assignmentCount"',
          //   children: 'Total Score',
          //   sortable: true,
          //   getter: (v, r) => ((r.assignmentCount||0) * 60),
          // },
          // {
          //   key: 'avgScore',
          //   children: '% of Score',
          //   sortable: true,
          //   getter: (v, r) => (
          //     r.assignmentCount
          //       ? `${Math.round((v / 60) * 10000) / 100}%`
          //       : '/'
          //   ),
          // },
          {
            key: 'completed',
            children: 'Completed Articles',
            sortable: true,
            getter: (v, r) => {
              console.log('🔍 Completed getter - v:', v, 'r.assignmentCount:', r.assignmentCount, 'r.completedPct:', r.completedPct);
              return r.assignmentCount
                ? `${v || 0} / ${r.assignmentCount}`
                : '/';
            },
          },
          {
            key: 'completedPct',
            children: 'Completed %',
            sortable: true,
            getter: (v, r) => {
              console.log('🔍 CompletedPct getter - v:', v, 'typeof v:', typeof v, 'r.assignmentCount:', r.assignmentCount);
              return r.assignmentCount
                ? `${Math.round(v * 10000) / 100}%`
                : '/';
            },
          },
          {
            key: 'avgCompletedScore',
            children: 'Avg. Score',
            sortable: true,
            getter: (v) => Math.round(v * 100) / 100,
          },
          // {
          //   key: 'acuScore',
          //   children: 'Accumulated Score',
          //   sortable: true,
          // },
          // {
          //   key: 'late',
          //   children: 'Total Late Assignment',
          //   getter: (v) => v || 0,
          // },
        ],
      }}
    >
      {/* {() => (
      <>
        <BtnDayRangePicker
          className="mr-2"
          value={filter.assignmentDate}
          onChange={(dateRange) => {
            setFilter({
              ...filter,
              assignmentDate: dateRange,
            });
          }}
          placeholder={t('Assignment Date')}
        />
        <BtnDayRangeWithTimePicker
          className="mr-2"
          value={filter.answerDate}
          onChange={(dateRange) => {
            setFilter({
              ...filter,
              answerDate: dateRange,
            });
          }}
          placeholder={t('Answer Date')}
          withTime
        />
      </>
      )} */}
    </ListResource>
  );
};

export default ListScores;
